import { ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output, inject, DestroyRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppService } from '../../../../app.service';
import { GlobalService } from '../../../../global/services/global.service';
import { ConfirmationModalConfig } from '../../../../shared/components/confirmation-modal/confirmation-modal.component';
import { GtwSnackbarService } from '../../../../shared/_services/gtw-snackbar.service';
import {
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
} from '../../../../shared/workspace-element-context';
import { WorkspaceService } from '../../../../workspace/workspace.service';
import { BepsRollforwardService } from './beps-rollforward.service';

@Component({
  selector: 'gtw-beps-rollforward',
  templateUrl: './beps-rollforward.component.html',
  styleUrls: ['./beps-rollforward.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BepsRollforwardComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  private readonly subs = new Subscription();

  confirmConfig: ConfirmationModalConfig = {
    title: 'Confirm Rollover',
    message: 'Are you sure you want to Rollover to next year??',
    iconClass: 'fa fa-sign-out',
    iconColor: 'txt-color-orange-dark',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    confirmButtonClass: 'btn-danger',
    cancelButtonClass: 'btn-default',
    showCancelButton: true,
    showConfirmButton: true,
    animationClass: 'animated fadeIn fast',
    loading: false,
    loadingText: 'Processing...',
  };

  filterParams: any = {};
  GENERAL_CONFIG: any = {};
  USER_SETTINGS: any = {};
  globalService: any = {};

  constructor(
    private bepsRollforwardService: BepsRollforwardService,
    private gtwSnackbarService: GtwSnackbarService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
      })
    );
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    this.GENERAL_CONFIG = generalConfigFromGlobal(this.gtwGlobal);
    this.globalService = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace);
    this.USER_SETTINGS = this.gtwApp.USER_SETTINGS || {};
    this.filterParams = normalizeFilterParams(activeScreen);
  }

  private get ssoId(): string {
    return this.USER_SETTINGS?.user?.sso_id ?? '';
  }

  private get baseUrl(): string {
    return this.GENERAL_CONFIG?.base_url ?? '';
  }

  private get taxYear(): string {
    const taxYear = this.filterParams?.tax_year ?? this.globalService?.tax_year ?? '';
    return String(taxYear);
  }

  onConfirm(): void {
    this.gtwSnackbarService.openSnackBar('Data Rollover is In-Progress.', 'gtw-snackbar--green');
    this.dispatchUpdate('cancel');

    this.bepsRollforwardService.rollforwardCbcrData(this.baseUrl, this.ssoId, this.taxYear).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (response) => {
        if (response?.callSuccess === '1') {
          this.gtwSnackbarService.openSnackBar(
            'Data Rollover completed Successfully.',
            'gtw-snackbar--green'
          );
        } else if (response?.errorMessage) {
          this.gtwSnackbarService.openSnackBar(response.errorMessage, 'gtw-snackbar--red');
        }
      },
      error: (error) => {
        this.gtwSnackbarService.openSnackBar(
          error?.message || 'Something went wrong while completing the data push, please try again!',
          'gtw-snackbar--red'
        );
      },
    });
  }

  onCancel(): void {
    this.dispatchUpdate('cancel');
  }

  private dispatchUpdate(detail: 'refresh' | 'cancel'): void {
    const updateEvent = new CustomEvent('request-grid-update', {
      detail,
      bubbles: true,
    });
    document.querySelector('gtw-beps-rollforward-ce')?.dispatchEvent(updateEvent);
  }
}
